<template>
  <div
    :class="classes"
    class="card auth-ui-card"
  >
    <div class="card-header auth-ui-card-header">
      <div
        v-if="hasSlot('header-title')"
        class="card-header-title is-centered auth-ui-card-header-title"
      >
        <slot name="header-title" />
      </div>
    </div>
    <div
      v-if="hasSlot('body')"
      class="card-content"
    >
      <slot name="body" />
    </div>
    <div
      v-if="hasSlot('footer')"
      class="card-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
/* ============
   * Card Component
   * ============
   *
   * A basic card component.
   *
   * Gives an idea how components work.
   */

import SlotMixin from '@/mixins/slot';

export default {
  /**
     * The name of the component.
     */
  name: 'Card',

  /**
     * The mixins that the component can use.
     */
  mixins: [
    SlotMixin,
  ],

  props: {
    classes: {
      type: String,
      default: '',
    },
  },
};
</script>
